import { defineNuxtMiddleware } from '@nuxtjs/composition-api';
/**
 * Файлы data.ts в pages не считаются страницами
 */
export default defineNuxtMiddleware(({ error, route }) => {
    if (route?.name?.endsWith('-data')) {
        error({ statusCode: 404 });
    }
});
